export const PREFERENCE_KEYS = {
    recentAppsPreferenceKey: 'recentlyUsedLinks'
}